import React from "react"
import styled from "styled-components"
import {observer} from "mobx-react";

const SwitchWrapper = styled.label`
    position: relative;
    display: inline-block;
    width: 100%;
    max-width: 70px;
    height: 34px;
`

const SwitchInput = styled.input`
    opacity: 0;
    width: 0;
    height: 0;

    /* ON state (left) */
    &:checked + span:before {
        transform: translateX(0);
        content: "ON";
        background-color: #2ecc71;
    }

    /* OFF state (right) */
    &:not(:checked) + span:before {
        transform: translateX(100%);
        content: "OFF";
        background-color: #e74c3c;
    }
`

const Slider = styled.span`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    transition: 0.4s;
    overflow: hidden;

    &:before {
        position: absolute;
        width: 48%;
        height: calc(100% - 4px); /* Fill almost all height */
        top: 2px; /* Top/bottom padding for spacing */
        left: 2px;
        transition: 0.4s;
        border-radius: 2px;
        color: white;
        font-weight: bold;
        font-size: 0.75em;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`

const ToggleSwitch = ({ id, handleSwitch, switchStatus }) => {
    return (
      <SwitchWrapper>
        <SwitchInput
          id={id}
          type="checkbox"
          checked={switchStatus}
          onChange={handleSwitch}
        />
        <Slider />
      </SwitchWrapper>
    )
}

export default observer(ToggleSwitch)
